export class Contact {
    name:any;
    email:string | undefined;
    message:string | undefined;
    constructor(
        ) {
        }
}
